import { useMemo } from "react";
import { LinksType } from "@volt_developers/react-ui-components";
import { AppAbilityType } from "./../context/Ability.context";
import { Route } from "../routes/RouteModel";
import cloneDeep from "lodash/cloneDeep";

function useMenu(routes: Route[], ability: AppAbilityType) {
  const menu: LinksType = useMemo(() => {
    const clonedRoutes = cloneDeep(routes);
    function filterPermittedRoutes(
      routes: Route[],
      ability: AppAbilityType
    ): Route[] {
      return routes
        .filter((route) =>
          route.can ? ability.can(route.can.do, route.can.on) : true
        )
        .map((route) => {
          if (route.children && route.children.length > 0) {
            route.children = filterPermittedRoutes(route.children, ability);
          }

          // after filtering children could change to 0, because of that we are removing children property
          if (route.children && route.children.length === 0) {
            delete route.children;
          }

          return route;
        });
    }

    return filterPermittedRoutes(clonedRoutes, ability);
  }, [routes, ability]);

  return { menu };
}

export { useMenu };
